import type { ReactNode } from "react";
import { Breadcrumbs } from "./breadcrumbs";
import { ReviewStamp } from "./review-stamp";
import { LEGAL_AUTHOR } from "../content/authors";

export function LegalPage({
  title,
  intro,
  lastReviewed,
  children,
}: {
  title: string;
  intro: string;
  lastReviewed: string;
  children: ReactNode;
}) {
  return (
    <article className="mx-auto max-w-3xl px-6 py-16 lg:px-8 lg:py-20">
      <Breadcrumbs
        items={[
          { label: "Home", path: "/" },
          { label: "Legal", path: "/legal/privacy" },
          { label: title, path: "" },
        ]}
      />
      <h1 className="mt-6 font-serif text-4xl text-foreground lg:text-5xl">{title}</h1>
      <p className="mt-4 text-base leading-relaxed text-muted-foreground">{intro}</p>
      <div className="mt-6">
        <ReviewStamp author={LEGAL_AUTHOR} lastReviewed={lastReviewed} />
      </div>
      <div className="article-markdown legal-prose mt-10 max-w-none">{children}</div>
    </article>
  );
}
